import Vue from 'vue'
import fetch from 'isomorphic-fetch'
import qs from 'qs'
import {device} from './storage'
import Api from '../utils/config'
import store from '../store/state'
import { agreementInfo } from '../service/index'
let jumpFlag = true;

function checkStatus(response) {


  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  if (response.status >= 400 && response.status < 500) {
    Vue.router.push('/campaigns')
    // window.location = '/login'
  }
  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}


function checkLogin(response) {
  if (response.status === -100) {
    let url = encodeURIComponent(window.location)
    let cid = '-1'
      let cid2 = getParameterByName("cid")
      if (jumpFlag) {
        jumpFlag = false
        if (!!Vue.router.currentRoute.query.cid) {
           cid = Vue.router.currentRoute.query.cid;
        }else if (!!cid2){
           cid = cid2;
        }
        window.location = Api.auth + (cid) + '?jumpUrl=' + url
        return response;
      }

  }

  //console.log(store.state.global.showAgreement)
  if (!store.state.global.showAgreement && response.status === -4) {
    //store.dispatch('displayAgreement',cid)
    //store.commit('TOGGLE_AGREEMENT',true)
    Vue.router.currentRoute.query.cid && store.dispatch('displayAgreement',Vue.router.currentRoute.query.cid)
  }
  return response
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, method, param) {
  const newOptions = {
    credentials: 'include',
    cache: 'no-cache',
    method: method ? method : 'GET',
  };
  newOptions.headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Credentials': true,
    "If-Modified-Since": "0",
    "Cache-Control": "no-cache",
    "Pragma":"no-cache"
  };
  param = param ? param : '';
//   const newOptions = { ...defaultOptions};
  if (newOptions.method === 'POST' || newOptions.method === 'PUT') {

    newOptions.body = JSON.stringify(param);//转成json字符串，看需要
    // newOptions.body = param;
  } else if (newOptions.method === 'GET') {
    url = `${url}?${qs.stringify(param)}`
  }
  // return fetch(`${"http://10.4.3.11:9084"}${url}`, newOptions)
  return fetch(url, newOptions)
    .then(checkStatus)
    .then(response => response.json())
    .then(checkLogin)
    .catch((error) => {
      if (error.code) {
        // Toast.fail(error.message, 3, null, true)
      } else if ('stack' in error && 'message' in error) {
        // Toast.fail(`${NetErrorMsg}`, 3, null, true)
      }
      return error.response;
    });
}



// WEBPACK FOOTER //
// ./src/utils/request.js